import { render, staticRenderFns } from "./scoreTemplate.vue?vue&type=template&id=487aa430&scoped=true&"
import script from "./scoreTemplate.vue?vue&type=script&lang=js&"
export * from "./scoreTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487aa430",
  null
  
)

export default component.exports